import { SellerMemberFragment } from '@gql'
import { useStoreState } from '@store/hooks'
import { useMemo } from 'react'

export default function useSellerMember(
  id?: string
): SellerMemberFragment | undefined {
  const sellerMembers = useStoreState((state) => state.seller.members)

  return useMemo(
    () =>
      sellerMembers
        ? sellerMembers?.find((m) => m.id === id || m.userId === id)
        : undefined,

    [sellerMembers, id]
  )
}
